import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SearchStacksForNavigationItem } from "shared/Stack/useSearchStacksForNavigation/gql";

const SpaceliftVcsRepoUsedByRowActionsCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<SearchStacksForNavigationItem>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Row actions">
        <DropdownMenuItem href={`/stack/${item.id}`}>Go to stack</DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default SpaceliftVcsRepoUsedByRowActionsCell;
